import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DpDatepickerComponent } from '../../common-component/dp-datepicker/dp-datepicker.component';
import { from } from 'rxjs';
import { CommonModule, formatDate } from '@angular/common';
import { AppConfigService } from '../../services/config/app-config.service';
import { DistrictListService } from '../../services/raintree/Transmission/district-list.service';
import { SatesListService } from '../../services/raintree/Transmission/sates-list.service';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { PincodeInterface } from '../../services/raintree/interfaces/pincode.interface';
import { PincodeTransmissionService } from '../../services/raintree/Transmission/pincode.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../common-component/loader/loader.component';

@Component({
  selector: 'app-oblate-filter-popup',
  standalone: true,
  imports: [
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    DpDatepickerComponent,
    MatFormFieldModule,
    MatSelectModule, MatAutocompleteModule,
    MatOptionModule,
    CommonModule, MatIconModule,
    LoaderComponent
  ],
  templateUrl: './oblate-filter-popup.component.html',
  styleUrls: ['./oblate-filter-popup.component.scss', '../../../styles/_dropdown.scss',],
})
export class OblateFilterPopupComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<OblateFilterPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private districtListService: DistrictListService,
    private stateListService: SatesListService,
    private pincodeTransmissionService: PincodeTransmissionService,
    private toaster: ToastrService
  ) { }
  @ViewChild('autopin') autopin!: MatAutocomplete;
  fromDate = new FormControl('');
  toDate = new FormControl('');
  stateName = new FormControl('');
  districtName = new FormControl('');
  memStatus = new FormControl('');
  recStatus = new FormControl('');
  pin = new FormControl('')
  memberStatus: any = ''
  recordStatus: any = ''
  pinList: any = []
  stateList: any = []
  districtList: any = []
  isLoading: boolean = false
  memStatusList: any[] = [
    {
      'id': "2",
      value: 'Active'
    },
    {
      'id': "3",
      value: 'Inctive'
    }

  ]
  recordStatusList: any[] = [
    {
      'id': "4",
      value: 'FW Pending'
    },
    {
      'id': "2",
      value: 'FW Completed'
    },
    {
      'id': "6",
      value: 'DA Rejected'
    },
    {
      'id': "7",
      value: 'SU Modified'
    },
    {
      'id': "5",
      value: 'DA Approved'
    },
    {
      'id': "8",
      value: 'SU Rejected'
    },
    {
      'id': "9",
      value: 'SU Approved'
    },
    {
      'id': "10",
      value: 'SU Reviewed'
    }

  ]
  ngOnInit(): void {
    if (this.data.state != '') {
      this.stateList = [{ state: this.data.state }]
      this.districtList = [this.data.district]
      this.stateName.setValue(this.data.state)
      this.districtName.setValue(this.data.district)
    } else
      this.getStatesList();
    if (this.data?.pin)
      this.pin.setValue(this.data?.pin)
    if (this.data?.memStatus) {
      this.memberStatus = this.data?.memStatus
      const statusvalue = this.memStatusList.find((item: any) => item.id === this.memberStatus)
      this.memStatus.setValue(statusvalue?.value)
    }
    if (this.data?.recStatus) {
      this.recordStatus = this.data?.recStatus
      const statusvalue = this.recordStatusList.find((item: any) => item.id === this.recordStatus)
      this.recStatus.setValue(statusvalue?.value)
    }
    this.pin.valueChanges.subscribe((item: any) => {
      if (item?.length === 6)
        this.getStateDistrictByPin(item)
      else if (item.length === 0) {
        this.getStatesList()
        this.stateName.setValue('')
        this.districtName.setValue('')
      }
    })
    this.fromDate.setValue(this.data.fromDate)
    this.toDate.setValue(this.data.toDate)
  }
  getStateDistrictByPin(item: any) {
    this.isLoading = true
    this.pincodeTransmissionService.getStateDistrict(item).subscribe({
      next: (response: PincodeInterface) => {
        if (!response.error) {
          const state: any = response.data.states
          this.stateList = [{ state: state[0] }]
          this.stateName.setValue(this.stateList[0].state)
          this.districtList = response.data.districts
          if (this.districtList.length === 1) {
            this.districtName.setValue(this.districtList[0])
          }
          this.isLoading = false

        }
      },
      error: (error: any) => {
        this.isLoading = false
        this.toaster.error(error)
      },

    });
  }

  onApplyClick() {
    let fromDate = this.fromDate.value !== '' ? formatDate(this.fromDate.value!, 'yyyy-MM-dd', 'en-US') : '';
    let toDate = this.toDate.value !== '' ? formatDate(this.toDate.value!, 'yyyy-MM-dd', 'en-US') : '';
    this.dialogRef.close({
      fromDate: fromDate,
      toDate: toDate,
      uiState: this.stateName.value,
      uiDistrict: this.districtName.value,
      pin: this.pin.value,
      memStatus: this.memberStatus,
      recStatus: this.recordStatus
    });
  }
  getDistrictList(state: any) {
    this.districtListService.getDistrictList(state).subscribe({
      next: (response: any) => {
        if (!response.error) {
          let resp = response.data;
          this.districtList = [];
          resp.forEach((elm: any) => {
            this.districtList.push(elm.district_name);
          });
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  getStatesList() {
    this.isLoading = true
    this.stateListService.getStatesList().subscribe({
      next: (response: any) => {
        if (!response.error) {
          this.stateList = []
          let resp = response.data;
          resp.forEach((elm: any) => {
            this.stateList.push({ state: elm.stateName });
          });
          this.isLoading = false
        }
      },
      error: (error) => {
        this.isLoading = false
        this.toaster.error(error)
      },
    });
  }
  onMemStatusChange(value: any) {
    this.memberStatus = value.id
  }
  onRecStatusChange(value: any) {
    this.recordStatus = value.id
  }
  clearMemStatus() {
    this.memStatus.setValue('')
    this.memberStatus = ''
  }
  clearRecStatus() {
    this.recStatus.setValue('')
    this.recordStatus = ''
  }
  onStateChange(value: any, i: any) {
    const pin: any = this.pin?.value
    if (pin.length !== 6) {
      this.getDistrictList(value);
      this.districtName.setValue('')
    }
  }
  clearState() {
    this.getStatesList()
    this.stateName.setValue('')
    this.districtName.setValue('')
    this.pin.setValue('')
    this.districtList = this.pinList = []
  }
  clearDistrict() {
    this.districtName.setValue('')
    this.getDistrictList(this.stateName.value)
  }
  onDistrictChange(value: any) {
    this.districtName.setValue(value)
  }
  closeDialog() {
    this.dialogRef.close(null)
  }

  onClear() {
    this.pin.setValue('');
    this.memStatus.setValue('');
    this.recStatus.setValue('');
  }
}
